import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import cx from 'classnames';
import { Icon } from '@storable/canaveral-components';
import FormFieldLabel from '../FormFieldLabel';
import FacilitySelect from '../../containers/FacilitySelect';
import styles from './styles.scss';

const propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  showDisabled: PropTypes.bool,
  tooltip: PropTypes.string,
};

const defaultProps = {
  showDisabled: undefined,
  tooltip: undefined,
};

const FormFieldFacilitySelect = ({
  name,
  label,
  showDisabled,
  tooltip,
  ...rest
}) => {
  const [field,, helpers] = useField(name);

  const fieldClasses = cx(
    styles.field,
  );

  return (
    <div className={fieldClasses}>
      <FormFieldLabel
        htmlFor={name}
        title={label}
        tooltip={tooltip}
      />
      <FacilitySelect
        {...rest}
        clearable
        showDisabled={showDisabled}
        onChange={option => helpers.setValue(option ? option.value : undefined)}
        value={field.value}
        placeholder={(
          <span className={styles.facilitySelect}>
            <Icon id="new-location" label="facility" className={styles.icon} />
            Select a facility from the list or start typing
          </span>
        )}
      />
    </div>
  );
};

FormFieldFacilitySelect.propTypes = propTypes;
FormFieldFacilitySelect.defaultProps = defaultProps;

export default FormFieldFacilitySelect;
